<template>

<v-layout class="fullpage">
    <v-toolbar height="70" class="" app fixed>
    <v-layout class="">
      
        <v-flex class = "ml-3">
          <v-toolbar-title :class="$vuetify.breakpoint.xsOnly ? 'topTitlePhone' : 'topTitle'">  
              <v-layout align-center row fill-height>     
            <img src="../images/ua_block_rgb_3.3c82a4c.png" :class="$vuetify.breakpoint.xsOnly ? 'blockaPhone mr-4' : 'blocka'">
            <a href="/" 
              style="text-decoration: none;" 
              :style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
                Interactive Floorplans 
            </a>
            </v-layout>
        </v-toolbar-title>  
      </v-flex>
    </v-layout>
  </v-toolbar>
  <form @submit.prevent="login(form)">
    <v-container grid-list-md 
      :style="!$vuetify.breakpoint.xsOnly ? 'margin-top: 200px;' : 'margin-top: 100px;' "
      style="margin-top: 100px;">
      <v-layout row justify-center>
        <v-flex xs6>
          <v-text-field name="netId"
            label="UA NetID"
            @click="setLoginFail(false)"
            v-model="form.netId"
            autocomplete="username"/>

          <v-text-field name="password"
            type="password"
            label="Password"
            v-model="form.password"
            autocomplete="current-password"/>
        </v-flex>
      </v-layout>

      <v-layout v-if="loginFail" class="text-xs-center" style="color: red;" justify-center>
        BLUECAT LOGIN FAILED
      </v-layout>
      <v-layout v-if="numberOfloginFails > 2" class="text-xs-center" style="color: red;" justify-center>
        <span class="font-italic">A known issue prevents the use of a leading or trailing space in the password.  We apologize for the inconvenience.</span>
      </v-layout>

      <v-layout column class="text-xs-center" justify-center>
        <v-flex xs6>
          <div>
            <v-btn type="submit" 
              round
              light
              color="primary"
              >
              Login
            </v-btn>
          </div>

          <div class="mt-4">
            University of Arizona access only.<br>
          </div>
        </v-flex>

        <v-flex xs6 class="mt-3">
              <v-btn round flat href="mailto:drennen@email.arizona.edu?subject=Interactive%20Floorplans%20Login">Help Contact</v-btn>
              <v-btn round flat href="https://www.youtube.com/embed/C-4aRXmrXsY">Demonstration Video</v-btn>
        </v-flex>       
      </v-layout>

      

    </v-container>
  </form>
</v-layout>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
	name: 'Login',
		data() {
			return {
				form: {
		          netId: '',
		          password: ''
		        }
         	}
		},

    computed: {
      ...mapState({ loginFail: state => state.user.loginFail, 
                    darkTheme: state=> state.ui.darkTheme,
                    numberOfloginFails: state => state.user.numberOfloginFails
      }),
    },

		methods: {
			...mapActions(['initializeData']),
      ...mapMutations([ 'setLoginFail', 'setBuildings']),
      
      login() {
        let redi = this.$route.query.redirect || '/'
        this.$store.dispatch('login', {...this.form }).then(() => {
            // refresh local data
            this.initializeData("force").then(() => {
              this.$router.replace(redi)
              //this.$router.push(this.$route.query.redirect || '/')
            })

            
        })
      },
      
			handleFeedback() {
        		// Do Something
      		}
		},
}
</script>

<style>
  .fullpage {
    display: absolute;
    flex-direction: column;
    flex: 1;
    z-index: 100000;
    position: fixed;
    top: 0px;
    width: 100vw;
    background-color: rgba(255, 255, 255, 1);
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0px;
    padding-top: 50px;
    margin-top: 0px;
    height: 100%;
  }

.topTitle {
  font-family: 'Open Sans', sans-serif;
  font-size: 25px;
}

.blocka {
  height: 45px;
  margin-right: 20px;
  margin-left: 20px;
  float: left;
}

.topTitlePhone {
  font-family: 'Open Sans', sans-serif;
  font-size: 20px;
  position:relative; top: -2px;
}

.blockaPhone {
  height: 45px;
  margin-right: 0px;
  margin-left: 0px;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/Login.vue